/* ListItem.tsx generated by @compiled/babel-plugin v0.36.1 */
/* eslint-disable @atlaskit/design-system/no-html-button */
import "./ListItem.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useEffect, useMemo, useRef } from 'react';
import { useIntl } from 'react-intl-next';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import ChevronRightIcon from '@atlaskit/icon/utility/chevron-right';
import Lozenge from '@atlaskit/lozenge';
import { fg } from '@atlaskit/platform-feature-flags';
import { Flex, Text } from '@atlaskit/primitives/compiled';
import Enter from '../../assets/Enter';
import { LogoSvg } from '../../assets/Logo';
import { messages } from './messages';
var contentStyles = {
  default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _ct361wug _slp31hna _1ul9l1r9 _1bto1l2s _o5721q9c"
};
var chevronIconStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var descriptionStylesUnbounded = null;
var descriptionStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var enterStylesUnbounded = null;
var enterStyles = null;
var statusStyles = {
  default: "_19bv1b66"
};

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var suggestionButtonStylesUnbounded = null;
var suggestionButtonStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var suggestionItemStylesUnbounded = null;
var suggestionItemStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var suggestionIconStylesUnbounded = null;
var suggestionIconStyles = null;
var suggestionListItemStyles = null;
var tellAILabelStyles = null;
var rovoSuggestionButtonStyles = null;
var rovoSuggestionIconStyles = null;

// Height of ListHeading component, used to calculate the scroll position.
// Kind of a hack, but it's the easiest way to get the height of the sticky group header.
var STICKY_GROUP_HEADER_HEIGHT = 32;
var ensureElementIsVisibleInScrollContainer = function ensureElementIsVisibleInScrollContainer(listItem, stickyHeaderHeight) {
  var _listItem$offsetParen;
  // ensure the structure of suggestions li element > ul (position relative) > scrollable div (overflow auto)
  var scrollContainer = (_listItem$offsetParen = listItem.offsetParent) === null || _listItem$offsetParen === void 0 ? void 0 : _listItem$offsetParen.parentElement;
  if (!scrollContainer || scrollContainer.tagName !== 'DIV') {
    return;
  }
  var scrollContainerRect = scrollContainer.getBoundingClientRect();
  var itemRect = listItem.getBoundingClientRect();

  // if highlighted item is above/below the current scroll viewport
  var itemNotVisible = listItem.offsetTop < scrollContainer.scrollTop || listItem.offsetTop + itemRect.height > scrollContainer.scrollTop + scrollContainerRect.height;
  if (itemNotVisible) {
    // Can't use item.scrollIntoView() because it moves the whole page too
    scrollContainer.scrollTo({
      top: listItem.offsetTop - stickyHeaderHeight,
      behavior: 'smooth'
    });
  }
};
var statusLozengeMessages = {
  beta: messages.suggestionStatusBeta,
  new: messages.suggestionStatusNew
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var suggestionIconContainerStylesUnbounded = null;
var suggestionIconContainerStyles = null;
var suggestionIconContainerBorderStyles = null;
export var ListItem = function ListItem(_ref) {
  var suggestion = _ref.suggestion,
    customLabel = _ref.customLabel,
    highlighted = _ref.highlighted,
    setSuggestion = _ref.setSuggestion,
    hasGroupHeading = _ref.hasGroupHeading;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var listItemRef = useRef(null);
  var hasChildren = useMemo(function () {
    return suggestion.childSuggestions && suggestion.childSuggestions.length;
  }, [suggestion.childSuggestions]);
  var updateSuggestion = React.useCallback(function (eventName) {
    if (setSuggestion) {
      setSuggestion(suggestion, eventName);
    }
  }, [setSuggestion, suggestion]);
  var onFocus = React.useCallback(function () {
    updateSuggestion('focus');
    suggestion.onSuggestionFocused();
  }, [updateSuggestion, suggestion]);
  var onMouseMove = React.useCallback(function () {
    updateSuggestion('mousemove');
  }, [updateSuggestion]);
  useEffect(function () {
    // If the item is highlighted and not hovered, scroll it into view
    if (highlighted && listItemRef.current && !listItemRef.current.matches(':hover')) {
      ensureElementIsVisibleInScrollContainer(listItemRef.current, hasGroupHeading ? STICKY_GROUP_HEADER_HEIGHT : 0);
    }
  }, [listItemRef, highlighted, hasGroupHeading]);
  var chevronRight = useMemo(function () {
    if (hasChildren && !highlighted) {
      return /*#__PURE__*/React.createElement("span", {
        className: ax(["_ca0qze3t _n3tdze3t _19bv1b66 _u5f31b66"])
      }, /*#__PURE__*/React.createElement(ChevronRightIcon, {
        label: "",
        color: "var(--ds-icon-subtle, #626F86)"
      }));
    }
    return null;
  }, [hasChildren, highlighted]);
  var statusLozengeText = suggestion.statusLozengeType && (statusLozengeMessages[suggestion.statusLozengeType] ? formatMessage(statusLozengeMessages[suggestion.statusLozengeType]) : null);
  return /*#__PURE__*/React.createElement("li", {
    ref: listItemRef,
    className: ax(["_qtt8glyw _19pkze3t"])
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: suggestion.onSelect,
    onMouseMove: onMouseMove,
    "data-testid": suggestion.testId || (customLabel ? "tell-ai" : suggestion.label),
    "data-highlighted": highlighted,
    onFocus: onFocus,
    className: ax(["_11c82smr _1bsb1osq _1tke1ylp _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _19pkze3t _1e0c1txw _2lx2vrvc _1bahv2br _4cvr1h6o _y3gn1e5h _k48pi7a9 _syaz1fxt", "_19itidpf _2rkoidpf _zulpw1gv _11q7glyw _13liidpf _qrwqidpf _p8yktlke _ga3t1dty _13l4166n _1jlo12j9 _1afz1i6y _1b6jsyzs _xa3z1lh4 _1lo213gf", fg('ai-smart-button-team-25') && "_zulputpp _1bsb1osq _19bvv47k _u5f3v47k _ca0q12x7 _n3td12x7 _19pkze3t _otyrze3t _18u0ze3t _2hwxze3t _1e0c1txw _1bahv2br _4cvr1h6o _y3gn1e5h _k48pi7a9 _syaz1fxt", fg('ai-smart-button-team-25') && "_19itidpf _11q7glyw _1tke1jfw _p8yktlke _ga3t1dty _13l4166n _1jlo12j9 _1afz1i6y _1b6jsyzs _xa3z1lh4 _1lo213gf", suggestion.value.includes('agent:') && "_1tke1a70"]),
    style: {
      "--_toyvsf": ix("2px solid ".concat("var(--ds-border-focused, #388BFF)"))
    }
  }, !suggestion.hideIcon && /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0c116y _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1tcg", "_xcdj1tcg _htdvgktf", fg('ai-smart-button-team-25') && "_1e0c1txw _4cvr1h6o _1bah1h6o", fg('ai-smart-button-team-25') && "_4t3ixy5q _1bsbxy5q", !suggestion.isAgent && fg('ai-smart-button-team-25') && "_2rkoglpi _189ee4h9 _1dqonqa1 _1h6dmuej", suggestion.value.includes('agent:') && "_4t3izwfg _1bsbzwfg"])
  }, suggestion.icon || (fg('ai-smart-button-team-25') ? /*#__PURE__*/React.createElement(AtlassianIntelligenceIcon, {
    spacing: "spacious",
    label: ""
  }) :
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  React.createElement(LogoSvg, {
    className: "default-icon",
    alt: ''
  }))), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    xcss: contentStyles.default
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, !customLabel ? /*#__PURE__*/React.createElement(Text, null, suggestion.label) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: ax(["_k48p1wq8 _2hwx1b66"])
  }, customLabel), " \"", suggestion.label, "\""), statusLozengeText && /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    xcss: statusStyles.default
  }, /*#__PURE__*/React.createElement(Lozenge, {
    appearance: "new"
  }, statusLozengeText))), suggestion.description && /*#__PURE__*/React.createElement("span", {
    className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8dcr7 _ct361wug _slp31hna _1ul9l1r9 _1bto1l2s _o5721q9c _syaz131l _1e0c1o8l", "_vwz4dlk8"])
  }, suggestion.description)), suggestion.rightText && /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest"
  }, suggestion.rightText), suggestion.value !== 'no-suggestions' && /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0cglyw _4t3igktf _1bsbgktf _syaz1gjq _bfhk166n", "_2rko1l7b _jbdb116y _w7a71h6o _1rrh1h6o"])
  }, /*#__PURE__*/React.createElement(Enter, null)), chevronRight));
};